"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItemGroup = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const utils_1 = require("@/utils");
const listItemGroupGapTokens = {
    '0': { gap: shared_styles_1.spaces['0'] },
};
/**
 * 같은 성격의 행을 세로로 묶어 하나의 목록으로 읽히게 하는 그룹.
 * 행 사이 간격과 list 의미를 그룹이 소유하고, 각 행은 자기 골격만 그린다.
 */
let ListItemGroup = class ListItemGroup extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.role = 'list';
        this.gap = '3';
    }
    render() {
        return (0, lit_1.html) `
      <slot @slotchange=${this.handleSlotChange}></slot>
    `;
    }
    // list는 자식이 listitem일 때만 목록으로 읽힌다. 행은 표현 전용이라 자기 role을 갖지 않으므로 그룹이 채운다.
    handleSlotChange() {
        if (this.role !== 'list')
            return;
        this.slotElements.forEach(element => {
            if (element.hasAttribute('role'))
                return;
            element.setAttribute('role', 'listitem');
        });
    }
};
ListItemGroup.styles = (0, lit_1.css) `
    :host {
      display: flex;
      flex-direction: column;
      gap: ${(0, lit_1.unsafeCSS)(shared_styles_1.spaces['3'])};
    }

    ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('gap', listItemGroupGapTokens))}
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], ListItemGroup.prototype, "role", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], ListItemGroup.prototype, "gap", void 0);
__decorate([
    (0, decorators_js_1.queryAssignedElements)({ flatten: true })
], ListItemGroup.prototype, "slotElements", void 0);
ListItemGroup = __decorate([
    (0, decorators_js_1.customElement)('mm-list-item-group')
], ListItemGroup);
exports.ListItemGroup = ListItemGroup;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGlzdC1pdGVtLWdyb3VwLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibGlzdC1pdGVtLWdyb3VwLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUFzRDtBQUN0RCxxREFBa0Y7QUFFbEYsK0RBQWdFO0FBQ2hFLG1DQUFtRTtBQU9uRSxNQUFNLHNCQUFzQixHQUFvRDtJQUM5RSxHQUFHLEVBQUUsRUFBRSxHQUFHLEVBQUUsc0JBQU0sQ0FBQyxHQUFHLENBQUMsRUFBRTtDQUMxQixDQUFBO0FBRUQ7OztHQUdHO0FBRUksSUFBTSxhQUFhLEdBQW5CLE1BQU0sYUFBYyxTQUFRLGdCQUFVO0lBQXRDOztRQVVzQyxTQUFJLEdBQXNCLE1BQU0sQ0FBQTtRQUNoQyxRQUFHLEdBQXFCLEdBQUcsQ0FBQTtJQW1CeEUsQ0FBQztJQWhCQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTswQkFDVyxJQUFJLENBQUMsZ0JBQWdCO0tBQzFDLENBQUE7SUFDSCxDQUFDO0lBRUQsd0VBQXdFO0lBQ2hFLGdCQUFnQjtRQUN0QixJQUFJLElBQUksQ0FBQyxJQUFJLEtBQUssTUFBTTtZQUFFLE9BQU07UUFFaEMsSUFBSSxDQUFDLFlBQVksQ0FBQyxPQUFPLENBQUMsT0FBTyxDQUFDLEVBQUU7WUFDbEMsSUFBSSxPQUFPLENBQUMsWUFBWSxDQUFDLE1BQU0sQ0FBQztnQkFBRSxPQUFNO1lBRXhDLE9BQU8sQ0FBQyxZQUFZLENBQUMsTUFBTSxFQUFFLFVBQVUsQ0FBQyxDQUFBO1FBQzFDLENBQUMsQ0FBQyxDQUFBO0lBQ0osQ0FBQzs7QUE1Qk0sb0JBQU0sR0FBRyxJQUFBLFNBQUcsRUFBQTs7OzthQUlSLElBQUEsZUFBUyxFQUFDLHNCQUFNLENBQUMsR0FBRyxDQUFDLENBQUM7OztNQUc3QixJQUFBLGVBQVMsRUFBQyxJQUFBLDJCQUFtQixFQUFDLEtBQUssRUFBRSxzQkFBc0IsQ0FBQyxDQUFDO0dBQ2hFLENBQUE7QUFDMEM7SUFBMUMsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLENBQUM7MkNBQWlDO0FBQ2hDO0lBQTFDLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDOzBDQUE0QjtBQUM1QjtJQUF6QyxJQUFBLHFDQUFxQixFQUFDLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDO21EQUFxQztBQVpuRSxhQUFhO0lBRHpCLElBQUEsNkJBQWEsRUFBQyxvQkFBb0IsQ0FBQztHQUN2QixhQUFhLENBOEJ6QjtBQTlCWSxzQ0FBYSJ9